import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>© Copyright Clínica Gerações - Todos os direitos reservados</p>
        <p className="footer-resp-tec">Resp.Téc: Dr. Marceu Lima CRM 52.84025-4 RQE 19162</p>
      </div>
    </footer>
  );
}

export default Footer;
